import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";



//
import { validateForm } from "../../../helper/helper";
import { Input } from "../../form/input";
import { GetMethod } from "../../../helper/Api";
import toast from "react-hot-toast";



function RegisterComponent() {
  // switchPage
  const search = useLocation().search;
  const phoneQuery = new URLSearchParams(search).get("phone");
  const [switchPage, setSwitchPage] = useState(1);
  //show password
  const [isShown, setIsShown] = useState(true);
  const { login } = useSelector((item) => item.user);
  var { t } = useTranslation()



  useEffect(() => {
    if (phoneQuery) {
      sendCodeAgain(phoneQuery)
    }
  }, [phoneQuery])


  ////show password
  const togglePassword = () => {
    setIsShown((item) => !item);
  };

  async function sendCodeAgain(phone) {
    setShow(false)
    var body1 = {
      phone: phone,
    };

    const res = await fetch(
      `${process.env.REACT_APP_SERVER}/api/user/code-again`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(body1),
      }
    )

    const result = await res.json()


    if (result.status === "success") {
      setPhone(phoneQuery)
      setSwitchPage(2)
      setShow(true)
    } else {
      setShow(true)
      toast.error(result.msg);
    }

  }


  useEffect(() => {
    // document.title = t("create_a_new_user_account");
    getCountry()
  }, [])


  ////useState for form Page 1
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("")
  const [username, setUsername] = useState("")
  const [errorUsername, setErrorUsername] = useState(null)
  const [password, setPassword] = useState("")
  const [repaidPassword, setRepaidPassword] = useState("")
  ////useState for form Page 2
  const [code, setCode] = useState("");
  const [getCountrys, setGetCountrys] = useState([])
  const [selectCountry, setSelectCountry] = useState({ value: '98', label: 'Iran', images: 'public/country/flags/mini/ir.png', id: '640ecf30bc2814a1cb546e9a' })

  const [show, setShow] = useState(true)
  const [email, setEmail] = useState("")


  const submitForms = async (e) => {
    // var history = useHistory();
    //refresh nashodn site bade click
    e.preventDefault();
    var isValid = true;




    if (password.length < 6) {
      toast.error(t("create_password_to_six") + " " + t("fill"))
      return isValid = false;
    }



    if (!selectCountry) {
      toast.error(t("select_the_country") + " " + t("fill"))
      return isValid = false;
    }



    if (password !== repaidPassword) {
      toast.error(t("password_not_the_same") + " " + t("fill"))
      return isValid = false;
    }


    if (login === true) {
      toast.error(t("You_currently_with_account") + " " + t("fill"))
      return isValid = false;
    }



    if (isValid) {
      //validation
      if (validateForm(e)) {



        setShow(false)
        var body1 = {
          name: fullName,
          phone: phone,
          username: username,
          password: password,
          country: selectCountry,
          email: email
        };




        const res = await fetch(
          `${process.env.REACT_APP_SERVER}/api/user/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify(body1),
          }
        )

        const result = await res.json()


        if (result.status === "success") {
          setSwitchPage(2)
          setShow(true)
        } else {
          setShow(true)
          toast.error(result.msg);
        }
      }
    }


  }


  ////get all country
  const getCountry = async () => {
    var url = "/api/country/site";

    const res = await GetMethod({ url: url })
    if (res.status === "success") {
      setGetCountrys([])
      res.data.map((item) => {
        if (item.flag_mini) {
          return setGetCountrys(country => [...country, { value: item?.number, label: item?.name_country, images: item?.flag_mini && item?.flag_mini, id: item?._id }])
        }
        return null;
      })
    }

  }

















  const submitFormsCode = async (e) => {
    e.preventDefault();

    if (code.length < 5) {
      toast.error(`${t("verification_code_is_incorrect")} ${t("fill")}`);
      return;
    }

    try {
      var body1 = {
        phone: phone,
        code: code
      };
      const response = await fetch(
        `${process.env.REACT_APP_SERVER}/api/user/code`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body1),
        }
      );

      const result = await response.json();
      if (result.status === "success") {
        toast.error(`${t("registration_was_successful")} ${t("fill")}`);
        setTimeout(() => {
          window.location.href = "/login"
        }, 1000);
      } else {
        setShow(true);
        toast.error(result.msg);
      }
    } catch (error) {
      console.log(error);
    }
  };









  // زدن اینتر
  function enterKeyPress(e) {
    if (e.key === "Enter") submitForms(e);
  }

  // زدن اینتر
  function enterKeyPressCode(e) {
    if (e.key === "Enter") submitFormsCode(e);
  }

  function alphacheck(e) {
    const regex = /[A-Za-z]/;
    const chars = e.target.value.split('');
    const char = chars.pop();
    if (!regex.test(char)) {
      e.target.value = chars.join('');
      setErrorUsername(t("please_use_english"))
      e.preventDefault();
      return false;
    }
    else {
      setErrorUsername(null)
      return true;
    }
  }






  const hanelValuePhone = () => {
    if (!selectCountry.value) {
      const errorMessage = `${t("select_the_country")} ${t("fill")}`;
      toast.error(errorMessage);
      return true;
    }

    return false;
  };


  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen" >

        <div className="flex flex-col text-gray-600 bg-white border rounded-xl md:w-[500px]">
          <div className="p-8 space-y-4">
            <div className="flex flex-col items-center justify-center gap-3">
              <img src={process.env.REACT_APP_ADDRESS + "/logo.png"} className="!min-h-0 w-[70px] h-[70px]" alt="logo" />
              <p className="text-lg font-bold text-black">
                {t("create_an_account")}
              </p>
              <p> {t("complete_the_form")}</p>
            </div>
            {switchPage === 1 && (
              <>
                <form className="w-full" onSubmit={submitForms}>
                  <div className="space-y-6">
                    <div className="relative ">
                      <Input
                        className={'w-80'}
                        placeholder={t("form_registration")}
                        type="text"
                        id={"name"}
                        name={"name"}
                        autoComplete={"off"}
                        requiredir={"true"}
                        onChange={(e) => setFullName(e.target.value)}
                      />
                    </div>

                    <div className="flex items-center m-auto ">

                      <div className="relative w-1/2 shrink-0 "
                        onClick={() => hanelValuePhone()}
                        dir="ltr"
                      >
                        <Input
                          className={`${phone.length > 0 && "text-left"}  pl-14 relative`}
                          placeholder={t("phone")}
                          type="text"
                          id={"phone"}
                          name={"phone"}
                          disabled={selectCountry.value ? false : true}
                          autoComplete={"off"}
                          value={phone}
                          requiredir={"true"}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                        <div className="absolute items-center left-2 top-3 "><p>{selectCountry && selectCountry.value && "+"}{selectCountry && selectCountry.value}</p></div>
                      </div>

                      <div className="relative w-1/2 " >
                        <ReactSelect
                          className="relative p-1 text-[12px]"
                          isDisabled
                          defaultValue={selectCountry}
                          options={getCountrys}
                          // onChange={(item) => {
                          //   setSelectCountry(item)
                          // }}
                          placeholder={t("select_the_country")}
                          formatOptionLabel={country => {
                            return (
                              <div className="flex justify-between w-full ">
                                <div className="flex items-center justify-center">
                                  <span > {country.value}+</span>
                                </div>
                                <div className="flex items-center ">
                                  <span className="text-[10px]  text-left ml-4  ">{country.label}</span>
                                  <img className="!min-h-[2rem]  w-8  rounded-lg object-contain " src={process.env.REACT_APP_CLIENT + "/" + country.images} alt="country" height={"20px"} width={"10px"} />
                                </div>
                              </div>
                            )
                          }
                          }
                        />
                      </div>
                    </div>

                    {selectCountry.value !== undefined && selectCountry.value !== "98" &&
                      <div className="relative ">
                        <Input
                          className={'w-80'}
                          placeholder="email"
                          type="text"
                          id={"email"}
                          name={"email"}
                          autoComplete={"off"}
                          requiredir={"true"}
                          onChange={(e) => setEmail(e.target.value)}

                        />
                      </div>
                    }




                    <div className="relative ">
                      <Input
                        className={'w-80 '}
                        placeholder={t("user_name")}
                        type="text"
                        id={"username"}
                        name={"username"}
                        pattern="[a-zA-Z]*"
                        autoComplete={"off"}
                        requiredir={"true"}
                        onKeyUp={alphacheck}
                        onChange={(e) => setUsername(e.target.value)}

                      />



                    </div>
                    {errorUsername && <span className="py-2 text-sm font-bold text-red-700">{t("please_use_english")}</span>}

                    <div className="flex gap-2">
                      <div className="relative w-1/2 ">
                        <input
                          onChange={(e) => setPassword(e.target.value)}
                          requiredir={"true"}
                          type={isShown ? "text" : "password"}
                          id="pass"
                          className=" block px-2.5 pb-2.5 pt-2 border w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                          placeholder=" "
                        />
                        <label
                          htmlFor="pass"
                          className="absolute text-sm text-gray-500  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white   peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
                        >
                          {t("password")}
                        </label>
                        <label className="absolute w-64 px-2 pt-3 mt-1 text-xs ">
                          {t("password_must_be_six_digits")}
                        </label>
                      </div>
                      <div className="relative w-1/2 ">
                        <input
                          type={isShown ? "text" : "password"}
                          id="pass2"
                          className=" block px-2.5 pb-2.5 pt-2 w-full text-sm text-gray-900 border bg-transparent rounded-lg  border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                          placeholder=" "
                          onChange={(e) => setRepaidPassword(e.target.value)}

                        />
                        <label
                          htmlFor="pass2"
                          className=" z-0 absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2  origin-[0] bg-white   peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
                        >
                          {t("repeat_the_password")}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 pt-10 mt-4 ">
                    <input
                      id="default-checkbox"
                      type="checkbox"
                      value=""
                      checked={isShown}
                      onChange={togglePassword}

                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <label
                      htmlFor="default-checkbox"
                      className="p-2 ml-2 text-sm font-medium text-gray-800 dark:text-gray-300"
                    >
                      {t("show_password")}
                    </label>
                  </div>

                  {show === true ? (
                    <div className="flex justify-center w-full">
                      <button
                        className="h-10 mt-5 text-white bg-blue-500 rounded-lg w-52"
                        onKeyPress={(e) => enterKeyPress(e)}
                      >
                        {t("register")}
                      </button>
                    </div>


                  ) :

                    (
                      <div className="flex justify-center w-full ">
                        <div className="relative ">
                          <button
                            className="h-10 pr-5 mt-5 text-white bg-blue-500 rounded-lg cursor-wait text-start text w-52"
                            disabled={true}
                          >

                            {t("wait")}
                          </button>
                          <div className="absolute rounded-lg left-10 top-[28px] ">

                            <span>
                              <svg className=" absolute animate-spin h-6 w-6 rounded-lg mr-3 bg-green-500" viewBox="0 0 24 24">
                              </svg>
                            </span>
                          </div>
                        </div>

                      </div>
                    )
                  }
                </form>
              </>
            )}

            {switchPage === 2 && (
              <>

                <div className="flex flex-col items-center justify-center gap-3">
                  <span>{t("code_for_the_number")} {phone} {t("sent")}</span>
                </div>
                <form onSubmit={submitFormsCode}>
                  <div className="space-y-6">
                    <div className="relative">
                      <input
                        onChange={(e) => setCode(e.target.value)}
                        requiredir={"true"}
                        type="text"
                        id="code"
                        className="  block  px-2.5 pb-2.5 pt-2 border w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                        placeholder="  "
                      />
                      <label
                        htmlFor="code"
                        className="absolute pr-3 text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white   peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 right-2"
                      >
                        {t("enter_code")}
                      </label>
                    </div>

                  </div>

                  {show === true ? (

                    <div className="flex justify-center w-full">
                      <button
                        className="h-10 mt-5 text-white bg-blue-500 rounded-lg w-52"
                        onKeyPress={(e) => enterKeyPressCode(e)}
                      >
                        {t("register_the_code")}

                      </button>
                    </div>
                  ) :

                    (
                      <div className="flex justify-center w-full">
                        <button
                          className="h-10 mt-5 text-white bg-blue-500 rounded-lg w-52"
                          disabled={true}
                        >
                          {t("register_the_code")}
                        </button>
                      </div>

                    )
                  }
                </form>
              </>
            )}

            <div className="mt-3 text-sm text-center">
              <Link to="/">
                <div className="flex justify-center w-full gap-1 mt-3 text-sm">
                  <div>
                    <p className="text-red-600"  > {t("have_you_registered")}   </p>
                  </div>
                  <div>
                    <p className="text-blue-600"  > {t("log_in")} </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div className={`${switchPage === 1 ? "hidden" : "flex"}  flex-col items-center `}>
            {/* <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=316885&Code=qvM9iKLkmLPVqqU4xaIJ">
              <img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=316885&Code=qvM9iKLkmLPVqqU4xaIJ" alt="not fond" className="!min-h-[100px] !h-[100px] cursor-pointer" id="qvM9iKLkmLPVqqU4xaIJ" />
            </a> */}
          </div>
        </div>
        {/* <ChangeLanguage language={"create_a_new_user_account"} /> */}
      </div>


    </>
  );
}

export default RegisterComponent;
